import { type GetBillingReturn, useBilling } from './useBilling';
import { useAgents } from './useAgents';
import type { AiAgent } from '@base/api';

export const computeCanDeployAgent = (
  billing: GetBillingReturn,
  agents: AiAgent[],
  tee?: boolean,
): boolean => {
  const countableAgents = agents
    .filter((a) => a.status !== 'Draft')
    .filter((a) => (tee ? a.tee : !a.tee));
  return (billing?.activePlans ?? 0) > countableAgents.length;
};

export const useCanDeployAgent = () => {
  const {
    tee: teeBilling,
    standard: standardBilling,
    refetch: refetchBilling,
    isPending: isBillingPending,
  } = useBilling();
  const { agents = [], refetchAgents, agentsPending } = useAgents();
  const canDeployTeeAgent = computeCanDeployAgent(teeBilling, agents, true);
  const canDeployStandardAgent = computeCanDeployAgent(standardBilling, agents);

  return {
    canDeployTeeAgent,
    canDeployStandardAgent,
    isPending: isBillingPending || agentsPending,
    refetch: async () => {
      const [agentsResult, billingResult] = await Promise.all([
        refetchAgents(),
        refetchBilling(),
      ]);

      return {
        canDeployTeeAgent: computeCanDeployAgent(
          billingResult.tee,
          agentsResult.data ?? [],
          true,
        ),
        canDeployStandardAgent: computeCanDeployAgent(
          billingResult.standard,
          agentsResult.data ?? [],
        ),
      };
    },
  };
};
